
<template>
  <!--开门日志-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="open_log_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <span>{{row.mobile}}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'openLog',
  data () {
    return {
      searchList: [
        { props: ['community_id'], placeholder: '小区名称', options: [], inputType: 'select' },
        { props: ['mobile'], placeholder: '手机号', options: [], inputType: 'input' },
        { props: ['open_type'], placeholder: '开门方式', options: [], inputType: 'select' },
        { props: ['is_success'], placeholder: '开门状态', options: this.$store.state.isSuccessList, inputType: 'select' },
        { props: ['create_date'], placeholder: ['开门时间', '开门时间'], options: [], inputType: 'dateTimePick' },
        { props: ['area_id'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['property_id'], placeholder: '物业', options: [], inputType: 'select' },
        { props: ['member_type'], placeholder: '开门人身份', options: [], inputType: 'select' },
        { props: ['device_id'], placeholder: '设备ID', options: [], inputType: 'input' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '查看', handle: (row) => this.showPicture(row.face_img), key: 'show' }
      ],
      columns: [
        { title: '开门时间', dataIndex: 'open_time', align: 'left', width: '' },
        { title: '所在小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '通行门', dataIndex: 'position_name', align: 'left', width: '' },
        { title: '设备名称', dataIndex: 'device_name', align: 'left', width: '' },
        { title: '身份', dataIndex: 'member_type_desc', align: 'left', width: '' },
        { title: '账号', dataIndex: 'mobile', align: 'left', width: '', scopedSlots: {customRender: 'action_t'} },
        { title: '卡号', dataIndex: 'cardno', align: 'left', width: '' },
        { title: '开门方式', dataIndex: 'open_type_desc', align: 'left', width: '' },
        { title: '状态', dataIndex: 'success_desc', align: 'left', width: '' },
        { title: '抓拍', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: undefined,
        mobile: undefined,
        open_type: undefined,
        is_success: undefined,
        create_date: undefined,
        area_id: undefined,
        property_id: undefined,
        member_type: undefined,
        device_id: undefined
      },
      listApi: {
        url: '/open_log',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {}
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      let paramArr = [
        {index: '2', key: 'open_type'},
        {index: '7', key: 'member_type'}
      ];
      this.deviceManageSelect(paramArr);
      this.regionSelect(5);
      this.communitySelect(0, 'searchList', 1);
      this.propertySelect(6);
    },
    showPic (url) {
      let waterUrl = this.waterMark({
        url: url,
        txt: '浩邈社区',
        // selector: 'myImg',
        xNum: 8,
        xDistance: 70,
        xAdd: 2,
        yNum: 12,
        yDistance: 50
      });
      console.log('waterUrl: ', waterUrl);
      // if (waterUrl) {
      //   window.open(waterUrl);
      // } else {
      //   this.$message.error('图片地址为空');
      // }
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/device/openLog.vue